// True while SetupPage would still show the onboarding task list: a SELF_SETUP_DASHBOARD
// checklist with tasks, on a venue not yet on the marketplace, until checklistCompleted.
// Done tasks alone don't count: SetupPage is what triggers the go-live that completes it.
export const isOnboardingInProgress = async (): Promise<boolean> => {
  const isAdministratorRole = App.isAdministrator() || App.isMasquerading();
  if (!isAdministratorRole || App.config.get('venue').listedOnMarketplace) {
    return false;
  }

  const venueId = App.getVenueId();
  const url = `/api/self-sign-up/venue/${venueId}/checklists`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok.');
  }

  const data = await response.json();
  const dashboardChecklist = data?.checklists?.find(({ type }) => type === 'SELF_SETUP_DASHBOARD');

  return Boolean(dashboardChecklist?.tasks?.length && !dashboardChecklist.checklistCompleted);
};
